import {Component, AfterViewInit, OnInit, Renderer2} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import {
  Router, NavigationStart, NavigationCancel, NavigationEnd, ActivatedRoute
} from '@angular/router';
import {JackpotConfigService} from './_services/jackpotConfig.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']

})
export class AppComponent implements OnInit, AfterViewInit {
  loading: boolean;
  title = 'app';
  referralURL: string;

  constructor(private translate: TranslateService,
              private activatedRoute: ActivatedRoute,
              private router: Router,
              public jackpotConfig: JackpotConfigService,
              private renderer: Renderer2) {

    this.referralURL = this.getQueryVariable();
    if (this.referralURL) {
      const url1 = (decodeURI(window.location.search.substring(1))).replace(/referral="([^"]*)"/, 'referral=' + encodeURIComponent(this.referralURL));
      if (window.location.pathname !== '/?') {
        this.router.navigateByUrl('?' + url1);
      } else {
        this.router.navigateByUrl(url1);
      }
    }

    const language = localStorage.getItem('pageLanguage');
    this.renderer.removeClass(document.body, 'withPreloader');
    this.loading = true;
    if (window.location.pathname !== '/') {
      if (window.location.pathname.toString().indexOf('/en/') === -1
        && window.location.pathname.toString().indexOf('/vi/') === -1
        && window.location.pathname.toString().indexOf('/id/') === -1
      ) {
        let url;
        if (language) {
          url = ('/' + language + window.location.pathname + window.location.search).replace(/\/(\s+)?$/, '');
          this.router.navigateByUrl(url);
        } else {
          url = ('/en' + window.location.pathname + window.location.search).replace(/\/(\s+)?$/, '');
          this.router.navigateByUrl(url);
        }
      }
    }

    this.activatedRoute.queryParams.subscribe(params => {
      if (params) {
        this.router.events
          .subscribe((event) => {
            if (event instanceof NavigationStart) {
              this.loading = true;
            } else if (event instanceof NavigationEnd || event instanceof NavigationCancel) {
              if (event.url.indexOf('redirectUrl=') > -1 || event.url.indexOf('package=') > -1) {
                setTimeout(() => {
                  this.loading = false;
                }, 3000);
              } else {
                setTimeout(() => {
                  this.loading = false;
                }, 1200);
              }
            }
          });
        }
    });
  }
  ngOnInit() {
  }
  getQueryVariable() {
    const query = window.location.search.substring(1);
    if (query && query.indexOf('referral=') > -1) {
      const decodeQuery = decodeURI(query);
      const  matchTextBetweenQuotes = decodeQuery.match(/referral="([^"]*)"/);
      return matchTextBetweenQuotes ? matchTextBetweenQuotes[1] : null;
    }
  }
  ngAfterViewInit() {
  }
}
